import { LocaleName } from '~/types'
import { CHANGE_LOCALE, changeLocale } from './actions'

export type LocaleState = LocaleName
type Action = ReturnType<typeof changeLocale> | { type: 'OTHER_ACTION'; payload?: any }

const initialState: LocaleState = 'de'

export * from './actions'
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (previousState = initialState, action: Action): LocaleState => {
  if (action.type === CHANGE_LOCALE) {
    return action.payload
  }
  return previousState
}
